module.exports = __webpack_public_path__ + "static/pricing-background-86b9bba0dd2f2d903625fdb3046a8bba.jpg";